var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('animation-frame',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }